import { useEffect, useState } from "react";
import { format, addDays } from "date-fns";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Button } from "./ui/button";
import { Field, SelectField } from "./common";
import { useData } from "../context/DataContext";

const TYPES = [{ id: "rendez-vous", label: "Rendez-vous" }, { id: "relance", label: "Rappel de relance" }];
const empty = (demandeId) => ({
  demande_id: demandeId || "", type: "rendez-vous", titre: "", lieu: "", notes: "", fait: false,
  date: format(addDays(new Date(), 1), "yyyy-MM-dd'T'10:00"),
});

export const RdvFormDialog = ({ open, onOpenChange, initial, demandeId }) => {
  const { save, demandes } = useData();
  const [f, setF] = useState(empty(demandeId));
  useEffect(() => { if (open) setF(initial ? { ...initial } : empty(demandeId)); }, [open, initial, demandeId]);
  const set = (k) => (v) => setF((p) => ({ ...p, [k]: v?.target ? v.target.value : v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!f.demande_id || !f.titre.trim() || !f.date) return toast.error("Client, titre et date sont obligatoires");
    try {
      await save("rdvs", f, initial?.id);
      toast.success(f.type === "relance" ? "Relance planifiée" : "Rendez-vous planifié");
      onOpenChange(false);
    } catch { toast.error("Erreur lors de l'enregistrement"); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="rdv-form-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">{initial ? "Modifier" : "Planifier"} un rendez-vous / une relance</DialogTitle>
          <DialogDescription>Les relances non traitées apparaissent en retard sur le tableau de bord.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="grid gap-4 sm:grid-cols-2">
            <Field label="Type"><SelectField testId="rdv-type-select" value={f.type} onChange={set("type")} options={TYPES} /></Field>
            <Field label="Date & heure"><Input data-testid="rdv-date-input" type="datetime-local" value={f.date} onChange={set("date")} /></Field>
          </div>
          <Field label="Client / demande">
            <SelectField testId="rdv-demande-select" value={f.demande_id} onChange={set("demande_id")} placeholder="Choisir un client"
              options={demandes.map((d) => ({ id: d.id, label: `${d.entreprise} — ${d.contact_nom}` }))} />
          </Field>
          <Field label="Objet"><Input data-testid="rdv-titre-input" value={f.titre} onChange={set("titre")} placeholder="Ex. Relance proposition" /></Field>
          <Field label="Lieu / canal"><Input data-testid="rdv-lieu-input" value={f.lieu} onChange={set("lieu")} placeholder="Visio, téléphone, locaux du client…" /></Field>
          <Field label="Notes"><Textarea data-testid="rdv-notes-input" rows={2} value={f.notes} onChange={set("notes")} /></Field>
          <div className="flex justify-end gap-3 pt-2">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
            <Button type="submit" className="kc-btn-primary" data-testid="rdv-form-submit-button">Enregistrer</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
